import { useEffect, useRef } from "react";

export function Checkbox({
  label,
  value,
  onClick,
  className,
  checked,
  disabled,
  indeterminate,
}: {
  label?: string | React.ReactNode;
  value?: string;
  onClick: (value: boolean) => void;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = !!indeterminate;
    }
  }, [indeterminate]);

  return (
    <label
      className={`${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"} ${className}`}
    >
      <input
        ref={inputRef}
        checked={!!checked}
        disabled={disabled}
        type="checkbox"
        value={value}
        onChange={(e) => onClick(!e.target.checked)}
      />
      {label}
    </label>
  );
}
